var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWoman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 103,
    viewBox: "0 0 90 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8 66.1064V76.9575C31.8 80.4841 28.72 82.0966 25.156 83.008L11.9802 86.4153C6.0424 87.9344 1.11 92.2011 1 96.4894V103",
    stroke: "#0061AA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2 66.1064V76.9575C58.2 80.4841 61.2799 82.0966 64.8439 83.008L78.0198 86.4153C83.9576 87.9344 88.89 92.2011 89 96.4894V103",
    stroke: "#0061AA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2 81.2979V31.383C14.2 14.6029 27.9896 1 45 1C62.0104 1 75.8 14.6029 75.8 31.383V81.2979",
    stroke: "#E37021",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34 22.702C30.7 25.6861 23 32.876 23 40.0637C23 45.3547 23 51.5941 23 55.2552C23 63.6648 34.275 67.3281 36.2 68.2765C38.125 69.2249 41.425 70.4467 45 70.4467C48.575 70.4467 51.875 69.2249 53.8 68.2765C55.725 67.3281 67 63.6648 67 55.2552C67 51.5919 67 43.1823 67 37.8935C67 37.8935 60.675 29.2127 49.4 29.2127C38.125 29.2127 31.8 23.2446 31.8 16.1914",
    stroke: "#0061AA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoman);
export default __webpack_public_path__ + "static/media/woman.fb59a79452c1b29c9eb874d12c79575f.svg";
export { ForwardRef as ReactComponent };